import { combineReducers } from 'redux';

import type { Action } from 'modules/global/generic.types';
import loading from 'modules/global/reducers/generic.loading';
import genericSelectSlice from 'modules/global/reducers/generic.selectSlice';
import loadingArraySlice from 'modules/global/reducers/loadingArraySlice';
import createSearchReducers from 'modules/global/reducers/simpleSearchReducer';
import type { MayBe } from 'modules/global/typing/common/common';
import * as types from 'modules/kiosks/actionTypes';
import { DASHBOARD_SOURCE, DETAILS_SOURCE } from 'modules/kiosks/constants';
import byDealerId from 'modules/kiosks/reducer/ui/byDealerId';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

import filters from './filters';

const dashboardSourceMatcher = ({ meta }: Action) => meta?.source === DASHBOARD_SOURCE;

const detailPageActionMatcher = ({ meta }: Action) => meta?.source === DETAILS_SOURCE;

const selectKioskLoadingId = (payload: MayBe<{ kioskId?: string }>): MayBe<string> => payload?.kioskId;

const LOADING_SLICE_CONFIG = {
  global: { matcher: dashboardSourceMatcher, selectId: selectKioskLoadingId },
};

const DETAILS_LOADING_CONFIG = { global: { matcher: detailPageActionMatcher } };

export default combineReducers({
  selects: genericSelectSlice(types.FETCH_KIOSKS),
  relays: genericSelectSlice(types.FETCH_AVAILABLE_RELAYS_REQUEST),
  dashboard: combineReducers({
    filters,
    patching: loadingArraySlice(types.PATCH_STATUS_REQUEST, LOADING_SLICE_CONFIG),
    deleting: loadingArraySlice(types.DELETE_REQUEST, LOADING_SLICE_CONFIG),
    data: createSearchReducers(types.FETCH_KIOSKS, {
      global: { matcher: dashboardSourceMatcher, paginationSlice: true },
    }),
  }),
  details: combineReducers({
    loading: combineReducers({
      update: loading(types.PUT_KIOSK, DETAILS_LOADING_CONFIG),
      create: loading(types.POST_KIOSK, DETAILS_LOADING_CONFIG),
      fetch: loading(types.FETCH_KIOSK, DETAILS_LOADING_CONFIG),
      configure: loading(types.CONFIGURE_REQUEST, DETAILS_LOADING_CONFIG),
    }),
    ready: createReducer<boolean>(false, {
      [types.SET_IS_READY]: () => true,
      [LOCATION_CHANGE]: () => false,
    }),
  }),
  byDealerId,
});
